import React from 'react';
import { Link } from 'react-router-dom';
import {
  Monitor,
  TrendingUp,
  Tag,
  Activity,
  Wrench,
  DollarSign,
} from 'lucide-react';
import {
  DropdownMenu as DropdownMenuPrimitive,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSeparator,
  DropdownMenuGroup,
  DropdownMenuLabel,
} from '../../ui/dropdown-menu';
import { Button } from '../../ui/button';

interface IDropdownMenuProps {
  pathname: string;
}

const DropdownMenu: React.FC<IDropdownMenuProps> = ({ pathname }) => {
  const isProductsActive = pathname.includes('/products');
  const isReportsActive = pathname.includes('/reports');

  return (
    <div className="flex items-center gap-1">
      <DropdownMenuPrimitive>
        <DropdownMenuTrigger asChild>
          <Button
            variant="ghost"
            className="px-4 py-2 text-sm font-medium rounded-md transition-colors"
            style={{
              backgroundColor: isProductsActive
                ? 'var(--neutral-beige)'
                : 'transparent',
              color: isProductsActive
                ? 'var(--primary-dark)'
                : 'var(--neutral-grey)',
            }}
            onMouseEnter={e => {
              if (!isProductsActive) {
                e.currentTarget.style.backgroundColor = 'var(--neutral-beige)';
                e.currentTarget.style.color = 'var(--primary-dark)';
              }
            }}
            onMouseLeave={e => {
              if (!isProductsActive) {
                e.currentTarget.style.backgroundColor = 'transparent';
                e.currentTarget.style.color = 'var(--neutral-grey)';
              }
            }}
          >
            Produtos
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" className="w-56">
          <DropdownMenuLabel>Gerenciar Produtos</DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuGroup>
            <DropdownMenuItem asChild>
              <Link
                to="/products/softwares"
                className="flex items-center gap-2 cursor-pointer"
              >
                <Monitor className="h-4 w-4" />
                <span>Softwares</span>
              </Link>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <Link
                to="/products/plans"
                className="flex items-center gap-2 cursor-pointer"
              >
                <TrendingUp className="h-4 w-4" />
                <span>Planos</span>
              </Link>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <Link
                to="/products/offers"
                className="flex items-center gap-2 cursor-pointer"
              >
                <Tag className="h-4 w-4" />
                <span>Ofertas</span>
              </Link>
            </DropdownMenuItem>
          </DropdownMenuGroup>
        </DropdownMenuContent>
      </DropdownMenuPrimitive>

      <DropdownMenuPrimitive>
        <DropdownMenuTrigger asChild>
          <Button
            variant="ghost"
            className="px-4 py-2 text-sm font-medium rounded-md transition-colors"
            style={{
              backgroundColor: isReportsActive
                ? 'var(--neutral-beige)'
                : 'transparent',
              color: isReportsActive
                ? 'var(--primary-dark)'
                : 'var(--neutral-grey)',
            }}
            onMouseEnter={e => {
              if (!isReportsActive) {
                e.currentTarget.style.backgroundColor = 'var(--neutral-beige)';
                e.currentTarget.style.color = 'var(--primary-dark)';
              }
            }}
            onMouseLeave={e => {
              if (!isReportsActive) {
                e.currentTarget.style.backgroundColor = 'transparent';
                e.currentTarget.style.color = 'var(--neutral-grey)';
              }
            }}
          >
            Relatórios
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" className="w-56">
          <DropdownMenuLabel>Ver Relatórios</DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuGroup>
            <DropdownMenuItem asChild>
              <Link
                to="/reports/subscriptions"
                className="flex items-center gap-2 cursor-pointer"
              >
                <Activity className="h-4 w-4" />
                <span>Assinaturas</span>
              </Link>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <Link
                to="/reports/actions"
                className="flex items-center gap-2 cursor-pointer"
              >
                <Wrench className="h-4 w-4" />
                <span>Ações</span>
              </Link>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <Link
                to="/reports/sales-comission"
                className="flex items-center gap-2 cursor-pointer"
              >
                <DollarSign className="h-4 w-4" />
                <span>Vendas</span>
              </Link>
            </DropdownMenuItem>
          </DropdownMenuGroup>
        </DropdownMenuContent>
      </DropdownMenuPrimitive>
    </div>
  );
};

export default DropdownMenu;
